import React from 'react';
import { useDispatch } from 'react-redux';

import { authActions } from '@ott/solar-auth';
import sendKM from '@ott/utility-km';

import { getAuthSelector } from 'src/redux/selectors/commonSelectors';

import FadeIn from 'src/components/elements/FadeIn/FadeIn';
import GradientButton from 'src/components/elements/GradientButton';

import { isUserAuthenticated } from 'src/helpers/user';
import useTypedSelector from 'src/hooks/useTypedSelector';

import { S3_MP4_URL } from '../../constants';

import styles from './ExploreStays.scss';

const ExploreStays = () => {
  const auth = useTypedSelector(getAuthSelector);

  const dispath = useDispatch();

  const handleButtonClick = () => {
    sendKM('SOLAR_CASH_BOOKSTAYSBUTTON_CLICK');

    if (isUserAuthenticated(auth)) {
      window.open('https://www.solartrip.com/en-us/hotels', '_blank');
    } else {
      dispath(authActions.showAuth());
    }
  };

  return (
    <FadeIn className={styles.exploreStays} delay={0.2}>
      <video
        autoPlay={true}
        preload="auto"
        loop={true}
        muted={true}
        playsInline={true}
        className={styles.video}
      >
        <source src={`${S3_MP4_URL}explore_stays.mp4`} type="video/mp4" />
      </video>
      <div className={styles.title}>
        {isUserAuthenticated(auth) ? (
          <>
            <FadeIn delay={0.4}>
              <span className={styles.titleThin}>Explore stays</span>
              <br />
              <span className={styles.subtitle}>and start earning Solar Cash</span>
            </FadeIn>
          </>
        ) : (
          <FadeIn delay={0.4}>
            Join us <br />
            <span className={styles.titleThin}>and start earning Solar Cash</span>
          </FadeIn>
        )}
      </div>
      <FadeIn delay={0.6}>
        <GradientButton className={styles.button} onClick={handleButtonClick}>
          {isUserAuthenticated(auth) ? 'Book stays' : 'Sign up'}
        </GradientButton>
      </FadeIn>
    </FadeIn>
  );
};

export default ExploreStays;
